import { Typography, TypographyTypeMap } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';
// import { TypographyProps } from '@mui/system';

export const MaxLengthText = ({
  num,
  ...otherProps
}: { num: number } & OverrideProps<TypographyTypeMap<{}, 'span'>, any>) => {
  return (
    <Typography
      align="right"
      color="rgba(17, 17, 17, 0.5)"
      fontSize={12}
      position="absolute"
      right={0}
      bottom={0}
      {...otherProps}
    >
      {num}
    </Typography>
  );
};
